import React from "react";

import { IconButton, Typography, Box, Tooltip } from "@mui/material";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import PauseRoundedIcon from "@mui/icons-material/PauseRounded";
import SkipNextRoundedIcon from "@mui/icons-material/SkipNextRounded";
import SkipPreviousRoundedIcon from "@mui/icons-material/SkipPreviousRounded";

import { formatMillisecondsToHHMMSS } from "../../../../../utils/formatMillisecondsToHHMMSS";

interface ControlsProps {
  isPlaying: boolean;
  currentTimestamp: number;
  durationInMilliseconds: number;
  onPlayPause: () => void;
  onPrevious: () => void;
  onNext: () => void;
}

export default function Controls({
  isPlaying,
  currentTimestamp,
  durationInMilliseconds,
  onPlayPause,
  onPrevious,
  onNext,
}: ControlsProps) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        <Tooltip title="Back 0.1s">
          <IconButton size="small" onClick={onPrevious}>
            <SkipPreviousRoundedIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title={isPlaying ? "Pause (Space)" : "Play (Space)"}>
          <IconButton
            onClick={onPlayPause}
            sx={{
              width: 40,
              height: 40,
              bgcolor: "primary.main",
              color: "primary.contrastText",
              boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
              "&:hover": { bgcolor: "primary.dark" },
            }}
          >
            {isPlaying ? <PauseRoundedIcon /> : <PlayArrowRoundedIcon />}
          </IconButton>
        </Tooltip>
        <Tooltip title="Forward 0.1s">
          <IconButton size="small" onClick={onNext}>
            <SkipNextRoundedIcon />
          </IconButton>
        </Tooltip>
      </Box>

      <Box
        sx={{
          px: 1.25,
          py: 0.5,
          borderRadius: 1.5,
          bgcolor: "action.hover",
          fontVariantNumeric: "tabular-nums",
          whiteSpace: "nowrap",
        }}
      >
        <Typography component="span" variant="body2" fontWeight={600}>
          {formatMillisecondsToHHMMSS(currentTimestamp)}
        </Typography>
        <Typography component="span" variant="body2" color="text.secondary">
          {" / "}
          {formatMillisecondsToHHMMSS(durationInMilliseconds)}
        </Typography>
      </Box>
    </Box>
  );
}
